import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_FILTER_VALUES } from '../constants/filterTypes';

export const listingsSlice = createSlice({
  name: 'listings',
  initialState: {
    listings: [],
    loading: false,
    error: null,
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0
    },
    filters: {
      ...DEFAULT_FILTER_VALUES
    },
    expandedRowKeys: [] // Để track các rows được expand
  },
  reducers: {
    setListings: (state, action) => {
      state.listings = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setExpandedRowKeys: (state, action) => {
      state.expandedRowKeys = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {
        ...DEFAULT_FILTER_VALUES
      };
    }
  }
});

export const {
  setListings,
  setLoading,
  setError,
  setPagination,
  setFilters,
  setExpandedRowKeys,
  clearFilters
} = listingsSlice.actions;

export default listingsSlice.reducer;